import { linkedInStore } from '../store/store';

export function isUnbound(): boolean {
    let store = linkedInStore();
    return store.status === 'Unbound';
}
